import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_4 = {
  for: "isProvider",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_7 = { class: "row mt-2" }
const _hoisted_8 = {
  for: "name",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_9 = { class: "col-sm-8" }
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = {
  for: "email",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_12 = { class: "col-sm-8" }
const _hoisted_13 = ["readonly"]
const _hoisted_14 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_15 = {
  for: "appId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_16 = { class: "col-sm-8" }
const _hoisted_17 = { class: "row mt-2" }
const _hoisted_18 = {
  for: "tgChatGroupId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_19 = { class: "col-sm-8" }
const _hoisted_20 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_21 = {
  for: "tgLowBalanceChatGroupId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_22 = { class: "col-sm-8" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "text-muted d-block mt-1" }
const _hoisted_25 = { class: "row mt-2" }
const _hoisted_26 = {
  for: "insuranceLimitUSDT",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_27 = { class: "col-sm-8" }
const _hoisted_28 = { class: "row mt-2" }
const _hoisted_29 = {
  for: "isManualWithdrawals",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_30 = { class: "col-sm-8" }
const _hoisted_31 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_32 = { class: "row mt-2" }
const _hoisted_33 = {
  for: "withdrawalAddress",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_34 = { class: "col-sm-8" }
const _hoisted_35 = { class: "row mt-2" }
const _hoisted_36 = {
  for: "isPayInTrafficBlocked",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_37 = { class: "col-sm-8" }
const _hoisted_38 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_39 = { class: "row mt-2" }
const _hoisted_40 = {
  for: "isPayOutTrafficBlocked",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_41 = { class: "col-sm-8" }
const _hoisted_42 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_43 = { class: "row mt-2" }
const _hoisted_44 = {
  for: "isEffectiveRateEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_45 = { class: "col-sm-8" }
const _hoisted_46 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_47 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_48 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_49 = { class: "col-sm-8" }
const _hoisted_50 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_51 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_52 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_53 = { class: "col-sm-8 d-flex align-items-center gap-2" }
const _hoisted_54 = { class: "text-muted" }
const _hoisted_55 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_56 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_57 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_58 = { class: "col-sm-8" }
const _hoisted_59 = { class: "form-check small mb-0" }
const _hoisted_60 = {
  class: "form-check-label",
  for: "autoCabinetBlockPayIn"
}
const _hoisted_61 = { class: "form-check small mb-0" }
const _hoisted_62 = {
  class: "form-check-label",
  for: "autoCabinetBlockPayOut"
}
const _hoisted_63 = {
  key: 6,
  class: "row mt-2"
}
const _hoisted_64 = {
  for: "isPayOutDisputeReminderToGroupChat",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_65 = { class: "col-sm-8" }
const _hoisted_66 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_67 = ["checked", "disabled"]
const _hoisted_68 = {
  key: 0,
  class: "text-warning d-block mt-1"
}
const _hoisted_69 = {
  key: 7,
  class: "row mt-2"
}
const _hoisted_70 = {
  for: "isConcurrentDealsLimitEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_71 = { class: "col-sm-8" }
const _hoisted_72 = { class: "d-flex align-items-center gap-2" }
const _hoisted_73 = { class: "form-check form-switch d-flex align-items-center mb-0" }
const _hoisted_74 = ["disabled"]
const _hoisted_75 = { class: "text-muted d-block mt-1" }
const _hoisted_76 = {
  key: 8,
  class: "row mt-2"
}
const _hoisted_77 = {
  for: "createInvite",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_78 = { class: "col-sm-8" }
const _hoisted_79 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_80 = {
  key: 9,
  class: "row mt-2"
}
const _hoisted_81 = {
  for: "2fa",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_82 = { class: "col-sm-8 align-items-center d-flex" }
const _hoisted_83 = {
  key: 0,
  class: "text-success"
}
const _hoisted_84 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_85 = {
  key: 10,
  class: "row mt-2"
}
const _hoisted_86 = {
  for: "password",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_87 = { class: "col-sm-8" }
const _hoisted_88 = {
  key: 11,
  class: ""
}
const _hoisted_89 = { class: "col-sm-4" }
const _hoisted_90 = ["for"]
const _hoisted_91 = ["onClick"]
const _hoisted_92 = {
  key: 1,
  class: "badge border border-primary bg-primary ms-2"
}
const _hoisted_93 = ["onClick"]
const _hoisted_94 = {
  key: 0,
  class: "fa fa-eye-slash"
}
const _hoisted_95 = {
  key: 1,
  class: "fa fa-eye"
}
const _hoisted_96 = { class: "col-sm-8" }
const _hoisted_97 = {
  key: 12,
  class: "row mt-2"
}
const _hoisted_98 = {
  for: "comment",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_99 = { class: "col-sm-8" }
const _hoisted_100 = {
  key: 13,
  class: "row mt-2"
}
const _hoisted_101 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_102 = { class: "col-sm-8 mt-1" }
const _hoisted_103 = ["readonly"]
const _hoisted_104 = {
  key: 14,
  class: "row mt-2"
}
const _hoisted_105 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_106 = { class: "col-sm-8 mt-1" }
const _hoisted_107 = ["readonly"]
const _hoisted_108 = {
  key: 15,
  class: "row mt-2"
}
const _hoisted_109 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_110 = { class: "col-sm-8 mt-1" }
const _hoisted_111 = { class: "text-secondary" }
const _hoisted_112 = {
  key: 16,
  class: "row mt-2"
}
const _hoisted_113 = {
  for: "disabledAfRules",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_114 = { class: "col-sm-8" }
const _hoisted_115 = {
  key: 17,
  class: "row mt-2"
}
const _hoisted_116 = {
  for: "isAlfaCardsEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_117 = { class: "col-sm-8" }
const _hoisted_118 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_119 = {
  key: 18,
  class: "row mt-2"
}
const _hoisted_120 = {
  for: "isDeviceSumCheckDisabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_121 = { class: "col-sm-8" }
const _hoisted_122 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_123 = ["disabled"]
const _hoisted_124 = {
  key: 19,
  class: "row mt-2"
}
const _hoisted_125 = {
  for: "isAvailable24",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_126 = { class: "col-sm-8" }
const _hoisted_127 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_128 = {
  key: 20,
  class: "row mt-2"
}
const _hoisted_129 = {
  for: "isRequisitesReuseEnable",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_130 = { class: "col-sm-8" }
const _hoisted_131 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_132 = {
  key: 21,
  class: "row mt-2"
}
const _hoisted_133 = {
  for: "isProviderLowBalanceAlertEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_134 = { class: "col-sm-8" }
const _hoisted_135 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_136 = { class: "row mt-2" }
const _hoisted_137 = {
  for: "disputeAutoClosePeriodMinutes",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_138 = { class: "col-sm-2" }
const _hoisted_139 = {
  key: 22,
  class: "row mt-2"
}
const _hoisted_140 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_141 = { class: "col-sm-8 d-flex align-items-end gap-2" }
const _hoisted_142 = {
  class: "flex-grow-0",
  style: {"min-width":"80px"}
}
const _hoisted_143 = {
  class: "text-muted d-block mb-1",
  style: {"font-size":"11px"}
}
const _hoisted_144 = {
  class: "flex-grow-0",
  style: {"min-width":"80px"}
}
const _hoisted_145 = {
  class: "text-muted d-block mb-1",
  style: {"font-size":"11px"}
}
const _hoisted_146 = {
  key: 23,
  class: "row mt-2"
}
const _hoisted_147 = {
  for: "payInRateSource",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_148 = { class: "col-sm-8" }
const _hoisted_149 = {
  key: 24,
  class: "row mt-2"
}
const _hoisted_150 = {
  for: "payOutRateSource",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_151 = { class: "col-sm-8" }
const _hoisted_152 = {
  key: 25,
  class: "row mt-2"
}
const _hoisted_153 = {
  for: "payInFixedRate",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_154 = { class: "col-sm-8" }
const _hoisted_155 = {
  key: 26,
  class: "row mt-2"
}
const _hoisted_156 = {
  for: "payOutFixedRate",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_157 = { class: "col-sm-8" }
const _hoisted_158 = {
  key: 27,
  class: "row mt-3"
}
const _hoisted_159 = { class: "col-sm-12" }
const _hoisted_160 = { class: "card" }
const _hoisted_161 = { class: "card-header" }
const _hoisted_162 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_163 = {
  class: "form-check-label ms-2",
  for: "showRequisitesLimits"
}
const _hoisted_164 = { class: "text-muted" }
const _hoisted_165 = {
  key: 0,
  class: "card-body"
}
const _hoisted_166 = { class: "col-sm-4 pe-2" }
const _hoisted_167 = { class: "form-label text-capitalize-first" }
const _hoisted_168 = { class: "col-sm-4 pe-2" }
const _hoisted_169 = { class: "form-label text-capitalize-first" }
const _hoisted_170 = { class: "d-flex align-items-stretch gap-2" }
const _hoisted_171 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_172 = { class: "col-sm-4" }
const _hoisted_173 = { class: "form-label text-capitalize-first" }
const _hoisted_174 = { class: "d-flex align-items-stretch gap-2" }
const _hoisted_175 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_176 = ["onClick", "title"]
const _hoisted_177 = { class: "row" }
const _hoisted_178 = { class: "col-sm-12" }
const _hoisted_179 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"z-index":"100000"}
}
const _hoisted_180 = { class: "modal-dialog" }
const _hoisted_181 = { class: "modal-content" }
const _hoisted_182 = { class: "modal-header" }
const _hoisted_183 = { class: "modal-title text-capitalize-first" }
const _hoisted_184 = { class: "modal-body" }
const _hoisted_185 = { class: "modal-footer border-top-0 d-flex justify-content-between" }
const _hoisted_186 = {
  key: 1,
  class: "modal-backdrop fade show",
  style: {"z-index":"99999"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TraderPlanSettingsBlock = _resolveComponent("TraderPlanSettingsBlock")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.is_provider")), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.isProvider) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isProvider"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isProvider]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.helper.trans("labels.name")), 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_FormInputWrapper, {
                errors: _ctx.getErrors(`name`)
              }, {
                default: _withCtx((parentProps) => [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass([parentProps.class, "form-control"]),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                    type: "text",
                    id: "name"
                  }, null, 2), [
                    [_vModelText, _ctx.form.name]
                  ])
                ]),
                _: 1
              }, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.helper.trans("labels.email")), 1),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_FormInputWrapper, {
                errors: _ctx.getErrors(`email`)
              }, {
                default: _withCtx((parentProps) => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
                    class: _normalizeClass([parentProps.class, "form-control"]),
                    readonly: !!_ctx.form.id,
                    type: "text",
                    id: "email"
                  }, null, 10, _hoisted_13), [
                    [_vModelText, _ctx.form.email]
                  ])
                ]),
                _: 1
              }, 8, ["errors"])
            ])
          ]),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.helper.trans("labels.domain")), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`appId`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "appId",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.appId,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.appId) = $event)),
                        options: _ctx.store.getters['getAppsIds'],
                        "custom-label": (opt) => _ctx.store.getters['getAppById'](opt)?.domain,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.helper.trans("labels.telegram_chat_id")), 1),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_FormInputWrapper, {
                errors: _ctx.getErrors(`tgChatGroupId`)
              }, {
                default: _withCtx((parentProps) => [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass([parentProps.class, "form-control"]),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.tgChatGroupId) = $event)),
                    type: "text",
                    id: "tgChatGroupId"
                  }, null, 2), [
                    [_vModelText, _ctx.form.tgChatGroupId]
                  ])
                ]),
                _: 1
              }, 8, ["errors"])
            ])
          ]),
          (_ctx.form.isProvider)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.helper.trans("labels.provider_low_balance_chat_id")), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`tgLowBalanceChatGroupId`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.tgLowBalanceChatGroupId) = $event)),
                        placeholder: _ctx.form.tgChatGroupId || '',
                        type: "text",
                        id: "tgLowBalanceChatGroupId"
                      }, null, 10, _hoisted_23), [
                        [_vModelText, _ctx.form.tgLowBalanceChatGroupId]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"]),
                  _createElementVNode("small", _hoisted_24, _toDisplayString(_ctx.helper.trans("labels.provider_low_balance_chat_id_hint")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.helper.trans("labels.insurance_limit")), 1),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_FormInputWrapper, {
                errors: _ctx.getErrors(`insuranceLimitUSDT`)
              }, {
                default: _withCtx((parentProps) => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.insuranceLimitUSDT) = $event)),
                    class: _normalizeClass([parentProps.class, "form-control"]),
                    type: "text",
                    id: "insuranceLimitUSDT"
                  }, null, 2), [
                    [_vModelText, _ctx.form.insuranceLimitUSDT]
                  ])
                ]),
                _: 1
              }, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.helper.trans("labels.isManualWithdrawals")), 1),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.isManualWithdrawals) = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  id: "isManualWithdrawals"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.isManualWithdrawals]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.helper.trans("labels.withdrawalAddress")), 1),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_FormInputWrapper, {
                errors: _ctx.getErrors(`withdrawalAddress`)
              }, {
                default: _withCtx((parentProps) => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.withdrawalAddress) = $event)),
                    class: _normalizeClass([parentProps.class, "form-control"]),
                    type: "text",
                    id: "withdrawalAddress"
                  }, null, 2), [
                    [_vModelText, _ctx.form.withdrawalAddress]
                  ])
                ]),
                _: 1
              }, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.helper.trans("labels.is_pay_in_traffic_blocked")), 1),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.isPayInTrafficBlocked) = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  id: "isPayInTrafficBlocked"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.isPayInTrafficBlocked]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.helper.trans("labels.is_pay_out_traffic_blocked")), 1),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.isPayOutTrafficBlocked) = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  id: "isPayOutTrafficBlocked"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.isPayOutTrafficBlocked]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.helper.trans("labels.show_effective_rate")), 1),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.isEffectiveRateEnabled) = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  id: "isEffectiveRateEnabled"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.isEffectiveRateEnabled]
                ])
              ])
            ])
          ]),
          (_ctx.form.id && (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead))
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.helper.trans("labels.autoCabinetBlock")), 1),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.isAutoCabinetBlockEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "autoCabinetBlockEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isAutoCabinetBlockEnabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.id && (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead) && _ctx.form.isAutoCabinetBlockEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.helper.trans("labels.autoCabinetBlockTimeout")), 1),
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`autoCabinetBlockTimeoutMinutes`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([parentProps.class, 'form-control', 'form-control-sm']),
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.autoCabinetBlockTimeoutMinutes) = $event)),
                        type: "number",
                        min: "1",
                        id: "autoCabinetBlockTimeoutMinutes",
                        style: {"max-width":"120px"}
                      }, null, 2), [
                        [_vModelText, _ctx.form.autoCabinetBlockTimeoutMinutes]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"]),
                  _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.helper.trans("labels.minutes")), 1),
                  (_ctx.autoCabinetBlockHoursText)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_55, _toDisplayString(_ctx.autoCabinetBlockHoursText), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.id && (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead) && _ctx.form.isAutoCabinetBlockEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.helper.trans("labels.autoCabinetBlockScope")), 1),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.isAutoCabinetBlockPayInEnabled) = $event)),
                      type: "checkbox",
                      id: "autoCabinetBlockPayIn"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isAutoCabinetBlockPayInEnabled]
                    ]),
                    _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.helper.trans("labels.autoCabinetBlockScopePayIn")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.isAutoCabinetBlockPayOutEnabled) = $event)),
                      type: "checkbox",
                      id: "autoCabinetBlockPayOut"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isAutoCabinetBlockPayOutEnabled]
                    ]),
                    _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.helper.trans("labels.autoCabinetBlockScopePayOut")), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.id && _ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.helper.trans("labels.pay_out_dispute_reminder_to_group_chat")), 1),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("input", {
                      checked: _ctx.form.isPayOutDisputeReminderToGroupChat,
                      onClick: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePayOutDisputeReminderToGroupChat && _ctx.togglePayOutDisputeReminderToGroupChat(...args)), ["prevent"])),
                      disabled: _ctx.isPayOutDisputeReminderToggleLoading,
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isPayOutDisputeReminderToGroupChat"
                    }, null, 8, _hoisted_67)
                  ]),
                  (_ctx.form.isPayOutDisputeReminderToGroupChat && !_ctx.form.tgChatGroupId)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_68, _toDisplayString(_ctx.helper.trans("labels.pay_out_dispute_reminder_to_group_chat_no_group_warning")), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.id && _ctx.concurrentDealsLimitEnabled && _ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.helper.trans("labels.concurrent_deals_limit")), 1),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.isConcurrentDealsLimitEnabled) = $event)),
                        class: "form-check-input",
                        type: "checkbox",
                        id: "isConcurrentDealsLimitEnabled"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.isConcurrentDealsLimitEnabled]
                      ])
                    ]),
                    _createVNode(_component_FormInputWrapper, {
                      errors: _ctx.getErrors(`concurrentDealsLimit`)
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass([parentProps.class, 'form-control', 'form-control-sm']),
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.concurrentDealsLimit) = $event)),
                          disabled: !_ctx.form.isConcurrentDealsLimitEnabled,
                          type: "number",
                          min: "1",
                          id: "concurrentDealsLimit",
                          style: {"max-width":"120px"}
                        }, null, 10, _hoisted_74), [
                          [
                            _vModelText,
                            _ctx.form.concurrentDealsLimit,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _: 1
                    }, 8, ["errors"])
                  ]),
                  _createElementVNode("small", _hoisted_75, _toDisplayString(_ctx.helper.trans("labels.concurrent_deals_limit_hint")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.form.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.helper.trans("labels.create_invite")), 1),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.createInvite) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "createInvite"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.createInvite]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.helper.trans("labels.2fa")), 1),
                _createElementVNode("div", _hoisted_82, [
                  (_ctx.form?.is2faEnabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(_ctx.helper.trans('labels.enabled')), 1))
                    : _createCommentVNode("", true),
                  (!_ctx.form?.is2faEnabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_84, [
                        _cache[50] || (_cache[50] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.disabled')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.form?.is2faEnabled)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn btn-danger ms-2 btn-sm text-capitalize-first",
                        onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.disable2fa(_ctx.form.id)), ["prevent"]))
                      }, _toDisplayString(_ctx.helper.trans("labels.disable")), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          ((_ctx.form.id || _ctx.form.createInvite === false) && _ctx.store.getters.hasPermission(_ctx.UserPermission.RESET_TRADER_PASSWORD))
            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.helper.trans("labels.password")), 1),
                _createElementVNode("div", _hoisted_87, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`password`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["input-group", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.password) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          type: "text",
                          id: "password"
                        }, null, 2), [
                          [_vModelText, _ctx.form.password]
                        ]),
                        _createElementVNode("button", {
                          onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.form.password = _ctx.helper.generatePassword()), ["prevent"])),
                          type: "button",
                          class: "btn btn-outline-secondary"
                        }, _cache[51] || (_cache[51] = [
                          _createElementVNode("i", { class: "fa fa-rotate" }, null, -1)
                        ]))
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.teamLeads, (teamLead, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row mt-2",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("label", {
                        for: `teamLead${index}`,
                        class: "col-form-label text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans("labels.teamlead")) + " L" + _toDisplayString(index + 1), 9, _hoisted_90),
                      (teamLead && _ctx.form.mainTeamLead?.id !== teamLead?.id)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: _withModifiers(($event: any) => (_ctx.setMainTeamLead(teamLead)), ["prevent"]),
                            class: "badge border border-primary text-primary ms-2",
                            style: {"cursor":"pointer"}
                          }, "main", 8, _hoisted_91))
                        : teamLead
                          ? (_openBlock(), _createElementBlock("span", _hoisted_92, "main"))
                          : _createCommentVNode("", true),
                      teamLead
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            onClick: _withModifiers(($event: any) => (_ctx.toggleTeamLeadVisibility(teamLead)), ["prevent"]),
                            class: "badge border border-dark text-dark ms-2",
                            style: {"cursor":"pointer","width":"35px"}
                          }, [
                            (_ctx.form.hiddenTeamLeads.includes(teamLead.id))
                              ? (_openBlock(), _createElementBlock("i", _hoisted_94))
                              : (_openBlock(), _createElementBlock("i", _hoisted_95))
                          ], 8, _hoisted_93))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getErrors(`teamLead${index}`)
                      }, {
                        default: _withCtx((parentProps) => [
                          _createVNode(_component_Multiselect, {
                            id: `teamLead${index}`,
                            class: _normalizeClass(["", parentProps.class]),
                            modelValue: _ctx.form.teamLeads[index],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.form.teamLeads[index]) = $event),
                            "track-by": "id",
                            options: _ctx.teamLeads,
                            "custom-label": (opt) => `${opt.name} (${opt.email})`,
                            "custom-value": (opt) => opt.id,
                            "select-label": "Select",
                            placeholder: "",
                            "open-direction": "bottom",
                            multiple: false,
                            searchable: true,
                            "internal-search": true,
                            "clear-on-select": false,
                            "close-on-select": true,
                            "options-limit": 100,
                            limit: 1000,
                            "show-no-results": false,
                            "hide-selected": false,
                            onSearchChange: _ctx.asyncFindTeamLeads,
                            loading: _ctx.isTeamLeadsSelectLoading
                          }, null, 8, ["id", "class", "modelValue", "onUpdate:modelValue", "options", "custom-label", "custom-value", "onSearchChange", "loading"])
                        ]),
                        _: 2
                      }, 1032, ["errors"])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.helper.trans("labels.comment")), 1),
                _createElementVNode("div", _hoisted_99, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`comment`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("textarea", {
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        rows: "3",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.comment) = $event)),
                        id: "comment"
                      }, null, 2), [
                        [_vModelText, _ctx.form.comment]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.form.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.helper.trans("labels.anti_fraud.pay_in_canceled_count")), 1),
                _createElementVNode("div", _hoisted_102, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`antiFraudSettings.payInCanceledCount`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([[parentProps.class, 'w-50'], "form-control form-control-sm"]),
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.antiFraudSettings.payInCanceledCount) = $event)),
                        type: "number",
                        id: "payInCanceledCount",
                        readonly: !_ctx.isAdmin,
                        min: "0",
                        onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.antiFraudSettings.payInCanceledCount = Math.max(0, Number($event.target.value) || 0)))
                      }, null, 42, _hoisted_103), [
                        [_vModelText, _ctx.antiFraudSettings.payInCanceledCount]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.form.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.helper.trans("labels.anti_fraud.active_disputes_threshold")), 1),
                _createElementVNode("div", _hoisted_106, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`antiFraudSettings.activeDisputesThreshold`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([[parentProps.class, 'w-50'], "form-control form-control-sm"]),
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.antiFraudSettings.activeDisputesThreshold) = $event)),
                        type: "number",
                        id: "activeDisputesThreshold",
                        readonly: !_ctx.isAdmin,
                        min: "1",
                        onInput: _cache[27] || (_cache[27] = ($event: any) => (_ctx.antiFraudSettings.activeDisputesThreshold = ($event.target as HTMLInputElement).value === '' ? null : Math.max(1, Number(($event.target as HTMLInputElement).value) || 0)))
                      }, null, 42, _hoisted_107), [
                        [_vModelText, _ctx.antiFraudSettings.activeDisputesThreshold]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.form.id && _ctx.stopScamEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.helper.trans("labels.anti_fraud.pay_out_fake_receipts_limit")), 1),
                _createElementVNode("div", _hoisted_110, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`antiFraudSettings.payOutFakeReceiptsLimit`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([[parentProps.class, 'w-50'], "form-control form-control-sm"]),
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.antiFraudSettings.payOutFakeReceiptsLimit) = $event)),
                        type: "number",
                        id: "payOutFakeReceiptsLimit",
                        min: "0",
                        onInput: _cache[29] || (_cache[29] = ($event: any) => (_ctx.antiFraudSettings.payOutFakeReceiptsLimit = ($event.target as HTMLInputElement).value === '' ? null : Math.max(0, Number(($event.target as HTMLInputElement).value) || 0)))
                      }, null, 34), [
                        [_vModelText, _ctx.antiFraudSettings.payOutFakeReceiptsLimit]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"]),
                  _createElementVNode("small", _hoisted_111, _toDisplayString(_ctx.helper.trans("labels.anti_fraud.pay_out_fake_receipts_count")) + ": " + _toDisplayString(_ctx.antiFraudSettings.payOutFakeReceiptsCount), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                _createElementVNode("label", _hoisted_113, _toDisplayString(_ctx.helper.trans("labels.disabledAfRules")), 1),
                _createElementVNode("div", _hoisted_114, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`disabledAfRules`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "disabledAfRules",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.disabledAfRules,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.disabledAfRules) = $event)),
                        options: Object.values(_ctx.AntiFraudAlertRule),
                        "custom-label": (opt) => _ctx.helper.trans(`antifraudalerts.rule.${opt}`),
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: true,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.helper.trans("labels.is_alfa_cards_enabled")), 1),
                _createElementVNode("div", _hoisted_117, [
                  _createElementVNode("div", _hoisted_118, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.isAlfaCardsEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isAlfaCardsEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isAlfaCardsEnabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.deviceSumCheckDisablingEnabled && (_ctx.isAdmin || _ctx.isOperator))
            ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                _createElementVNode("label", _hoisted_120, _toDisplayString(_ctx.helper.trans("labels.is_device_sum_check_disabled")), 1),
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("div", _hoisted_122, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.isDeviceSumCheckDisabled) = $event)),
                      disabled: !_ctx.isAdmin,
                      onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.onDeviceSumCheckDisabledClick && _ctx.onDeviceSumCheckDisabledClick(...args))),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isDeviceSumCheckDisabled"
                    }, null, 8, _hoisted_123), [
                      [_vModelCheckbox, _ctx.form.isDeviceSumCheckDisabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                _createElementVNode("label", _hoisted_125, _toDisplayString(_ctx.helper.trans("labels.isAvailable24")), 1),
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("div", _hoisted_127, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.isAvailable24) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isAvailable24"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isAvailable24]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.helper.trans("labels.isRequisitesReuseEnable")), 1),
                _createElementVNode("div", _hoisted_130, [
                  _createElementVNode("div", _hoisted_131, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.isRequisitesReuseEnable) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isRequisitesReuseEnable"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isRequisitesReuseEnable]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.isProvider)
            ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                _createElementVNode("label", _hoisted_133, _toDisplayString(_ctx.helper.trans("labels.provider_low_balance_alert")), 1),
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.isProviderLowBalanceAlertEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isProviderLowBalanceAlertEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isProviderLowBalanceAlertEnabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_136, [
            _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.helper.trans("labels.disputeAutoClosePeriodMinutes")), 1),
            _createElementVNode("div", _hoisted_138, [
              _createVNode(_component_FormInputWrapper, {
                errors: _ctx.getErrors(`disputeAutocloseAt`)
              }, {
                default: _withCtx((parentProps) => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.disputeAutoClosePeriodMinutes) = $event)),
                    class: _normalizeClass([parentProps.class, "form-control form-control-sm"]),
                    type: "text",
                    id: "disputeAutoClosePeriodMinutes"
                  }, null, 2), [
                    [_vModelText, _ctx.form.disputeAutoClosePeriodMinutes]
                  ])
                ]),
                _: 1
              }, 8, ["errors"])
            ])
          ]),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.helper.trans("labels.nightDisputeAutoClose")), 1),
                _createElementVNode("div", _hoisted_141, [
                  _createElementVNode("div", _hoisted_142, [
                    _createElementVNode("small", _hoisted_143, _toDisplayString(_ctx.helper.trans("labels.hours")), 1),
                    _createVNode(_component_FormInputWrapper, {
                      errors: _ctx.getErrors(`nightDisputeAutoCloseHour`)
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.nightDisputeAutoCloseHour) = $event)),
                          onChange: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.onNightDisputeAutoCloseHourChange && _ctx.onNightDisputeAutoCloseHourChange(...args))),
                          class: _normalizeClass([parentProps.class, "form-control form-control-sm"]),
                          type: "number",
                          min: "4",
                          max: "14",
                          id: "nightDisputeAutoCloseHour"
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.form.nightDisputeAutoCloseHour,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _: 1
                    }, 8, ["errors"])
                  ]),
                  _cache[52] || (_cache[52] = _createElementVNode("span", {
                    class: "mb-2",
                    style: {"font-size":"16px","font-weight":"bold"}
                  }, ":", -1)),
                  _createElementVNode("div", _hoisted_144, [
                    _createElementVNode("small", _hoisted_145, _toDisplayString(_ctx.helper.trans("labels.minutes")), 1),
                    _createVNode(_component_FormInputWrapper, {
                      errors: _ctx.getErrors(`nightDisputeAutoCloseMinutes`)
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.nightDisputeAutoCloseMinutes) = $event)),
                          onChange: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.onNightDisputeAutoCloseMinutesChange && _ctx.onNightDisputeAutoCloseMinutesChange(...args))),
                          class: _normalizeClass([parentProps.class, "form-control form-control-sm"]),
                          type: "number",
                          min: "0",
                          max: "59",
                          id: "nightDisputeAutoCloseMinutes"
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.form.nightDisputeAutoCloseMinutes,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _: 1
                    }, 8, ["errors"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                _createElementVNode("label", _hoisted_147, _toDisplayString(_ctx.helper.trans("labels.rate_source")) + ", in", 1),
                _createElementVNode("div", _hoisted_148, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`payInRateSource`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "payInRateSource",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.payInRateSource,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.payInRateSource) = $event)),
                        options: _ctx.store.getters['rateSources/all'],
                        "custom-label": (opt) => _ctx.store.getters['rateSources/get'](opt)?.name,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                _createElementVNode("label", _hoisted_150, _toDisplayString(_ctx.helper.trans("labels.rate_source")) + ", out", 1),
                _createElementVNode("div", _hoisted_151, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`payOutRateSource`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "payOutRateSource",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.payOutRateSource,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.form.payOutRateSource) = $event)),
                        options: _ctx.store.getters['rateSources/all'],
                        "custom-label": (opt) => _ctx.store.getters['rateSources/get'](opt)?.name,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                _createElementVNode("label", _hoisted_153, _toDisplayString(_ctx.helper.trans("labels.fixedRatePayIn")), 1),
                _createElementVNode("div", _hoisted_154, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`payInFixedRate`),
                    class: "row"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.payInFixedRate) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "payInFixedRate"
                        }, null, 2), [
                          [_vModelText, _ctx.form.payInFixedRate]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                _createElementVNode("label", _hoisted_156, _toDisplayString(_ctx.helper.trans("labels.fixedRatePayOut")), 1),
                _createElementVNode("div", _hoisted_157, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`payOutFixedRate`),
                    class: "row"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.form.payOutFixedRate) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "payOutFixedRate"
                        }, null, 2), [
                          [_vModelText, _ctx.form.payOutFixedRate]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                _createElementVNode("div", _hoisted_159, [
                  _createElementVNode("div", _hoisted_160, [
                    _createElementVNode("div", _hoisted_161, [
                      _createElementVNode("div", _hoisted_162, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.showRequisitesLimits) = $event)),
                          class: "form-check-input",
                          type: "checkbox",
                          id: "showRequisitesLimits"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.showRequisitesLimits]
                        ]),
                        _createElementVNode("label", _hoisted_163, _toDisplayString(_ctx.helper.trans("labels.requisites_limits")), 1)
                      ]),
                      _createElementVNode("small", _hoisted_164, _toDisplayString(_ctx.helper.trans("labels.requisites_limits_description")), 1)
                    ]),
                    (_ctx.showRequisitesLimits)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.requisitesLimits, (limit, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "row mb-3"
                            }, [
                              _createElementVNode("div", _hoisted_166, [
                                _createElementVNode("label", _hoisted_167, _toDisplayString(_ctx.helper.trans("labels.currency")), 1),
                                _createVNode(_component_FormInputWrapper, {
                                  errors: _ctx.getErrors(`requisitesLimits.${index}.currency`)
                                }, {
                                  default: _withCtx((parentProps) => [
                                    _createVNode(_component_Multiselect, {
                                      class: _normalizeClass(["multiselect-sm", parentProps.class]),
                                      modelValue: limit.currency,
                                      "onUpdate:modelValue": ($event: any) => ((limit.currency) = $event),
                                      options: _ctx.store.getters['currencyMethods/currencies'],
                                      searchable: true,
                                      "close-on-select": true,
                                      placeholder: _ctx.helper.trans('placeholders.select_currency')
                                    }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "options", "placeholder"])
                                  ]),
                                  _: 2
                                }, 1032, ["errors"])
                              ]),
                              _createElementVNode("div", _hoisted_168, [
                                _createElementVNode("label", _hoisted_169, _toDisplayString(_ctx.helper.trans("labels.min_amount_for_deal")), 1),
                                _createElementVNode("div", _hoisted_170, [
                                  _createVNode(_component_FormInputWrapper, {
                                    errors: _ctx.getErrors(`requisitesLimits.${index}.amountLimitForDeal`),
                                    class: "flex-grow-1"
                                  }, {
                                    default: _withCtx((parentProps) => [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((limit.amountLimitForDeal) = $event),
                                        class: _normalizeClass([parentProps.class, "form-control form-control-sm"]),
                                        type: "text",
                                        placeholder: _ctx.helper.trans('placeholders.enter_amount')
                                      }, null, 10, _hoisted_171), [
                                        [_vModelText, limit.amountLimitForDeal]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["errors"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_172, [
                                _createElementVNode("label", _hoisted_173, _toDisplayString(_ctx.helper.trans("labels.max_amount_for_deal")), 1),
                                _createElementVNode("div", _hoisted_174, [
                                  _createVNode(_component_FormInputWrapper, {
                                    errors: _ctx.getErrors(`requisitesLimits.${index}.maxAmountLimitForDeal`),
                                    class: "flex-grow-1"
                                  }, {
                                    default: _withCtx((parentProps) => [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((limit.maxAmountLimitForDeal) = $event),
                                        class: _normalizeClass([parentProps.class, "form-control form-control-sm"]),
                                        type: "text",
                                        placeholder: _ctx.helper.trans('placeholders.enter_amount')
                                      }, null, 10, _hoisted_175), [
                                        [_vModelText, limit.maxAmountLimitForDeal]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["errors"]),
                                  _withDirectives((_openBlock(), _createElementBlock("button", {
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.removeRequisitesLimit(index)),
                                    class: "btn btn-outline-danger text-nowrap btn-sm",
                                    title: _ctx.helper.trans('labels.remove_requisites_limit')
                                  }, _cache[53] || (_cache[53] = [
                                    _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                                  ]), 8, _hoisted_176)), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      { hover: true }
                                    ]
                                  ])
                                ])
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_177, [
                            _createElementVNode("div", _hoisted_178, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.addRequisitesLimit && _ctx.addRequisitesLimit(...args))),
                                class: "btn btn-outline-primary btn-sm"
                              }, [
                                _cache[54] || (_cache[54] = _createElementVNode("i", { class: "fa fa-plus" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("labels.add_requisites_limit")), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_TraderPlanSettingsBlock, {
            trader: _ctx.form,
            onPlanUpdated: _ctx.handlePlanUpdate
          }, null, 8, ["trader", "onPlanUpdated"])
        ])
      ]),
      _createVNode(_component_ConfirmModal, { ref: "tradersConfirmModal" }, null, 512)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.deviceSumCheckConfirmModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
            _createElementVNode("div", _hoisted_180, [
              _createElementVNode("div", _hoisted_181, [
                _createElementVNode("div", _hoisted_182, [
                  _createElementVNode("h5", _hoisted_183, _toDisplayString(_ctx.helper.trans('labels.is_device_sum_check_disabled')), 1)
                ]),
                _createElementVNode("div", _hoisted_184, _toDisplayString(_ctx.helper.trans('labels.is_device_sum_check_disabled_hint')), 1),
                _createElementVNode("div", _hoisted_185, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-dark btn-sm text-capitalize-first",
                    onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.deviceSumCheckConfirmModal = false))
                  }, _toDisplayString(_ctx.helper.trans('button.no')), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-danger btn-sm text-capitalize-first",
                    onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.confirmDeviceSumCheckDisabled && _ctx.confirmDeviceSumCheckDisabled(...args)))
                  }, _toDisplayString(_ctx.helper.trans('button.yes')), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.deviceSumCheckConfirmModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_186))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}